<template>
  <d-page-layout :hasSearch="false">
    <template slot="heading">
      <v-breadcrumbs class="pa-0" :items="items"></v-breadcrumbs>
    </template>
    <template slot="content">
      <d-loading class="mb-4" v-if="loading"></d-loading>
      <template v-else>
        <v-row>
          <v-col cols="12" md="4" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("projects.add.form.name") }}:
            </h6>
            <p class="mb-0">{{ project.name }}</p>
          </v-col>

          <v-col cols="12" md="8" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("projects.add.form.description") }}:
            </h6>
            <p class="mb-0">{{ project.description }}</p>
          </v-col>
        </v-row>
        <BaseLog :getLogs="getLogs"></BaseLog>
      </template>
    </template>
  </d-page-layout>
</template>
  <script>
import BaseLog from "@/components/BaseLog/BaseLog.vue";
import { getProjectById, getProjectLogs } from "@/services/project";

export default {
  components: {
    BaseLog,
  },
  data: (vm) => ({
    items: [
      {
        text: vm.$t("projects.page-heading"),
        disabled: false,
        to: "/projects",
      },
      {
        text: "",
        disabled: true,
      },
      {
        text: vm.$t("project-apis.text.logs"),
        disabled: true,
      },
    ],
    project: null,
    loading: true,
  }),
  methods: {
    getLogs() {
      return getProjectLogs(this.$route.params.id);
    },
  },
  async created() {
    try {
      this.loading = true;
      this.project = await getProjectById(this.$route.params.id).then(
        (res) => res.data
      );
      this.$eventBus.$emit("fetchLogs");
      this.items[1].text = this.project?.name;
    } finally {
      this.loading = false;
    }
  },
};
</script>
  